import { useEffect, useState } from "react";
import { JourneyShell } from "@/components/journey/JourneyShell";
import { Button } from "@/components/ui/button";
import { useJourneyContent } from "@/hooks/useJourneyContent";
import { approveAdminOrder, getAdminOrders } from "@/lib/journeyApi";
import "@/pages/Journey.css";

export default function AdminOrders() {
  const { ui, loading } = useJourneyContent();
  const [orders, setOrders] = useState([]);
  const [completed, setCompleted] = useState({});

  useEffect(() => {
    let active = true;
    getAdminOrders().then((data) => { if (active) setOrders(data); });
    return () => { active = false; };
  }, []);

  if (loading || !ui) return <div className="journey-loading" data-testid="admin-loading-state" />;
  const copy = ui.admin_approve;
  const approve = async (ref) => {
    const result = await approveAdminOrder(ref);
    setCompleted((current) => ({ ...current, [ref]: result.already ? copy.already : `${copy.done.split(".")[0]}.` }));
    setOrders((current) => current.map((order) => order.ref === ref ? { ...order, state: "paid" } : order));
  };

  return (
    <JourneyShell>
      <section className="journey-panel journey-panel--wide" data-testid="admin-orders-panel">
        <h1 data-testid="admin-title">{copy.title}</h1>
        <div className="journey-admin-list" data-testid="admin-order-list">
          {orders.map((order) => {
            const body = copy.body.replace("{invoice_ref}", order.ref).replace("{name}", order.name || "").replace("{email}", order.email || "").replace("{symbol}", order.symbol || "").replace("{amount}", order.amount).replace("{currency}", order.currency);
            return (
              <article key={order.order_id} data-testid={`admin-order-${order.ref}`}>
                <p>{body}</p>
                {completed[order.ref] ? <strong data-testid={`admin-order-result-${order.ref}`}>{completed[order.ref]}</strong> : order.state === "paid" ? <strong>{copy.already}</strong> : <Button onClick={() => approve(order.ref)} data-testid={`admin-approve-${order.ref}`}>{copy.button}</Button>}
              </article>
            );
          })}
        </div>
      </section>
    </JourneyShell>
  );
}